<template>
  <Section
    :id="id"
    :header="t('rateShop.rateShop')"
    class="quick-quote-rate-shop p-0"
  >
    <RateShop
      :id="`${id}-rate-shop`"
      :total-mileage-override="mileage"
      :rate-shop="rateShop"
    />
  </Section>
</template>

<script lang="ts" setup>
import { PropType, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { Loadable } from '@rygen/rygen-ui/model';

import { RateShop as RateShopModel } from '@/model';

import RateShop from '@/components/rateShop/RateShop.vue';
import Section from '@rygen/rygen-ui/components/ui/Section.vue';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  rateShop: {
    type: Object as PropType<Loadable<RateShopModel>>,
    default: () => ({ loading: false }),
  },
  mileage: {
    type: Number,
    default: undefined,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});
const { id, mileage, rateShop } = toRefs(props);
const { t } = useI18n();
</script>
